var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"registration-btns",on:{"click":function($event){$event.preventDefault();return _vm.$emit('next')}}},[_vm._v("Next")])}
var staticRenderFns = []

export { render, staticRenderFns }